import {
  AgeDetails,
  EmotionDetails,
  IvideonFaceAnalytics,
  IvideonVehicleAnalytics,
  VisitTimeDetails,
} from "~/entity/Ivideon/model/schema";

const EMPTY_AGE_DETAILS: AgeDetails = {
  "<18": 0,
  "18-24": 0,
  "25-34": 0,
  "35-44": 0,
  "45-64": 0,
  ">65": 0,
};

const EMPTY_VISIT_TIME_DETAILS: VisitTimeDetails = {
  "<5min": 0,
  "5-10min": 0,
  "10-30min": 0,
  "30-60min": 0,
  ">60min": 0,
};

const EMPTY_EMOTION_DETAILS: EmotionDetails = {
  happiness: 0,
  sadness: 0,
  neutral: 0,
  anger: 0,
  surprise: 0,
  fear: 0,
  disgust: 0,
  other: 0,
};

export const normalizeFaceAnalytics = (
  raw?: Partial<IvideonFaceAnalytics> | null,
): IvideonFaceAnalytics => ({
  totalFaces: raw?.totalFaces ?? 0,
  uniqueFaces: raw?.uniqueFaces ?? 0,
  newFaces: raw?.newFaces ?? 0,
  returningFaces: raw?.returningFaces ?? 0,
  overallAverageDwellTime: raw?.overallAverageDwellTime ?? 0,
  totalAgeDetails: { ...EMPTY_AGE_DETAILS, ...raw?.totalAgeDetails },
  totalGenderDetails: { male: 0, female: 0, ...raw?.totalGenderDetails },
  totalMaskDetails: { yes: 0, no: 0, ...raw?.totalMaskDetails },
  totalVisitTimeDetails: {
    ...EMPTY_VISIT_TIME_DETAILS,
    ...raw?.totalVisitTimeDetails,
  },
  totalEmotionDetails: {
    ...EMPTY_EMOTION_DETAILS,
    ...raw?.totalEmotionDetails,
  },
  periodStats: raw?.periodStats ?? [],
  subscriptionStats: raw?.subscriptionStats ?? [],
});

const EMPTY_COLOR_DETAILS = {
  black: 0,
  white: 0,
  gray: 0,
  silver: 0,
  red: 0,
  blue: 0,
  green: 0,
  yellow: 0,
  brown: 0,
  other: 0,
};

const EMPTY_VEHICLE_TYPE_DETAILS = {
  vehicle: 0,
  truck: 0,
  bus: 0,
  motorcycle: 0,
  other: 0,
};

const EMPTY_DIRECTION_DETAILS = {
  forward: 0,
  backward: 0,
  unknown: 0,
};

const EMPTY_RECOGNITION_DETAILS = {
  recognized: 0,
  unrecognized: 0,
  noPlate: 0,
};

export const normalizeVehicleAnalytics = (
  raw?: Partial<IvideonVehicleAnalytics> | null,
): IvideonVehicleAnalytics => ({
  totalVehicles: raw?.totalVehicles ?? 0,
  uniqueVehicles: raw?.uniqueVehicles ?? 0,
  newVehicles: raw?.newVehicles ?? 0,
  returningVehicles: raw?.returningVehicles ?? 0,
  totalColorDetails: { ...EMPTY_COLOR_DETAILS, ...raw?.totalColorDetails },
  totalVehicleTypeDetails: {
    ...EMPTY_VEHICLE_TYPE_DETAILS,
    ...raw?.totalVehicleTypeDetails,
  },
  totalDirectionDetails: {
    ...EMPTY_DIRECTION_DETAILS,
    ...raw?.totalDirectionDetails,
  },
  totalRecognitionDetails: {
    ...EMPTY_RECOGNITION_DETAILS,
    ...raw?.totalRecognitionDetails,
  },
  periodStats: raw?.periodStats ?? [],
  subscriptionStats: raw?.subscriptionStats ?? [],
});
